import {makeStyles} from '@material-ui/core/styles'

export const useStyles = makeStyles(theme=>({
    timeline_header:{
        marginTop: '-6px'
    },
    timeline_firstItem:{
        minHeight: '4rem'
    },
    timeline_dot_header:{
        backgroundColor: 'orange',
        fontSize: 'small',
        
    },
    timeline_dot:{
        border: '3px solid orange',
        
    },
    separator_padding:{
        paddingLeft: '11px',
       
    },
    timeline_end:{
        marginLeft: '12px',
        backgroundColor: 'orange',
    }

    
     
   
    
}))